import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FileDescriptionException, FileException, FileExceptionType } from '@cargos/sprintpay-models';
import { FileAPIService, FileAttachmentService } from '@cargos/sprintpay-services';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FileRequestService {
    constructor(
        private fileAttachmentService: FileAttachmentService,
        private fileService: FileAPIService,
        private domSanitizer: DomSanitizer
    ) {}

    /**
     * Function to upload files to BackEnd
     * @returns {Observable<string>} This function returns the file location
     * @param {FormData} file File uploaded
     */
    uploadFile(file: FormData): Observable<string> {
        return this.fileAttachmentService.uploadAttachment(file);
    }

    removeFileSelected(fileName: string): Observable<string> {
        return this.fileAttachmentService.removeAttachment(fileName).pipe(
            map(() => 'Complete'),
            catchError(() =>
                throwError(() =>
                    FileException.fromJson({
                        code: FileExceptionType.DELETE_ERROR,
                        description: FileDescriptionException[5],
                    })
                )
            )
        );
    }

    /**
     * @method downloadFile()
     * @param path
     * @param nameFile
     * @description Function that download the file
     */
    downloadFile(path: string, nameFile: string): Observable<Blob> {
        return this.fileService.downloadFileRequest(path).pipe(
            map((fileDownload: Blob) => {
                this.handleDownloadFile(fileDownload, nameFile);
                return fileDownload;
            })
        );
    }

    /**
     * @method handleDownloadFile()
     * @param (rawFile: Blob)
     * @param (fileName: string)
     * @description Prepare and download file
     */
    handleDownloadFile(rawFile: Blob, fileName: string): void {
        const link = document.createElement('a');
        const file = new Blob([rawFile], { type: rawFile.type });
        const url = this.domSanitizer.sanitize(
            SecurityContext.URL,
            this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file))
        );

        if (url) {
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    }
}
